import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import IncreaseLowRiskLimitModal from 'apps/auth/components/history/modals/IncreaseLowRiskLimitModal';
import { INCREASE_LIMITS_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { SCREEN } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { CLOSE_TO_LIMIT } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const PromoLowRiskUpgradeLimit = (props) => {
    const { notNowButton, quickHeadsUpPurple, quickHeadsUp, increaseLimitButton } = usePageMessages();

    useEffect(() => {
        amplitude.getInstance().logEvent(INCREASE_LIMITS_SHOWN, { [SCREEN]: CLOSE_TO_LIMIT });
    }, []);

    const text = (
        <>
            <span>{quickHeadsUpPurple}</span>
            <br />
            {quickHeadsUp}
        </>
    );

    return (
        <InfoPage
            iconName="zap-80"
            iconColor="primary"
            headerText={text}
            topButtonType="link"
            topButtonCaption={notNowButton}
            topButtonLink={AUTH_SEND_MAIN_LINK}
            primaryButtonCaption={increaseLimitButton}
            primaryButtonType="link"
            primaryButtonOnClick={(e) => {
                e?.preventDefault();
                props.modalRef.current.open(<IncreaseLowRiskLimitModal modalRef={props.modalRef} notNowLink={AUTH_SEND_MAIN_LINK} />);
            }}
        />
    );
};
PromoLowRiskUpgradeLimit.propTypes = {
    modalRef: PropTypes.object.isRequired,
};

export default PromoLowRiskUpgradeLimit;
